import React from 'react';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';
import styles from './phase-three.module.scss';

const Image = () => {
  const data = useStaticQuery(graphql`
    {
      file: contentfulTwilloPhase3 {
        image {
          fluid(maxWidth: 700) {
            ...GatsbyContentfulFluid_tracedSVG
          }
        }
      }
    }
  `);
  return (
    <Img
      className={styles.image}
      style={{ zIndex: '101' }}
      fluid={data.file.image.fluid}
    />
  );
};

export default Image;
